export default "__VITE_ASSET__DxUG$8Xh__"